import { Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import store from '@store/store.ts'
import ErrorBoundary from '@components/ErrorBoundary.tsx'
import { getCurrentUser } from '@selectors/data/user_selectors.js'
import SuspenseFallback from '@components/SuspenseFallback.tsx'
import defineAbilityFor from './ability.js'
import { AbilityContext } from './can.js'

const View = lazy(() => import('@features/views/components/View.tsx'))

window.Timetoast.views = {
  ...window.Timetoast.views,
  show: {
    init: function ({ viewUuid, tableId }) {
      const currentUser = getCurrentUser(store.getState())
      const ability = defineAbilityFor(currentUser)

      const root = createRoot(document.getElementById('react-target'))
      root.render(
        <ErrorBoundary>
          <Provider store={store}>
            <AbilityContext.Provider value={ability}>
              <Suspense fallback={<SuspenseFallback />}>
                <View tableId={tableId} viewUuid={viewUuid} />
              </Suspense>
            </AbilityContext.Provider>
          </Provider>
        </ErrorBoundary>
      )
    },
  },
}
